import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erro500',
  templateUrl: './erro500.component.html',
  styleUrls: ['./erro500.component.css']
})
export class Erro500Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
